import { render, staticRenderFns } from "./ListDashboardsDrawer.vue?vue&type=template&id=5ab556dd"
import script from "./ListDashboardsDrawer.vue?vue&type=script&lang=js"
export * from "./ListDashboardsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports